import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

// Pantalla de "Sin conexión al servidor" con Reintentar -- misma que el Tablero de Seguimiento.
// kind: 'network' (el backend no responde) | 'server' (respondió con error).
const ServerUnavailable = ({ kind = 'network', onRetry }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '70vh',
      gap: 3,
      p: 4,
    }}
  >
    {/* Ilustración SVG: cable desconectado */}
    <svg width="220" height="180" viewBox="0 0 220 180" xmlns="http://www.w3.org/2000/svg">
      <rect x="10" y="40" width="78" height="100" rx="10" fill="#e3f2fd" stroke="#90caf9" strokeWidth="2"/>
      <rect x="30" y="62" width="14" height="22" rx="4" fill="#1976d2" opacity="0.35"/>
      <rect x="54" y="62" width="14" height="22" rx="4" fill="#1976d2" opacity="0.35"/>
      <rect x="39" y="94" width="20" height="16" rx="10" fill="#1976d2" opacity="0.35"/>
      <path d="M 155 90 C 155 120, 140 140, 115 158" stroke="#ff7043" strokeWidth="7" fill="none" strokeLinecap="round"/>
      <rect x="130" y="68" width="42" height="36" rx="6" fill="#ff7043"/>
      <rect x="140" y="52" width="7" height="20" rx="3" fill="#bf360c"/>
      <rect x="153" y="52" width="7" height="20" rx="3" fill="#bf360c"/>
      <text x="97" y="72" fontSize="22" fill="#ffa726">⚡</text>
      <circle cx="108" cy="90" r="4" fill="#1976d2" opacity="0.5"/>
      <circle cx="120" cy="88" r="3" fill="#1976d2" opacity="0.35"/>
      <circle cx="130" cy="85" r="2" fill="#1976d2" opacity="0.2"/>
    </svg>

    <Typography variant="h5" fontWeight="bold" color="text.primary">
      Sin conexión al servidor
    </Typography>
    <Typography variant="body1" color="text.secondary" textAlign="center" maxWidth={380}>
      {kind === 'network'
        ? 'No se pudo conectar con el servidor. Verifica que el backend esté activo e intenta de nuevo.'
        : 'El servidor respondió con un error inesperado. Intenta recargar la página.'}
    </Typography>
    <Button
      variant="contained"
      startIcon={<RefreshIcon />}
      onClick={onRetry}
      sx={{ mt: 1, borderRadius: 2, px: 4 }}
    >
      Reintentar
    </Button>
  </Box>
);

export default ServerUnavailable;
